import { request } from "./api-require";
import { objAny } from "../common/common-interface";
// const API_URL = "/basic-system/v1";

//非实名在线卡---电卡会员状态
export const getRechargecardStatistics = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    "/oms-operation-service/v1/recharge_card/statistics",
    data,
    config
  );
};

//非实名在线卡---今年数据
export const getRechargecardTotal = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request("/oms-order-service/v1/card/recode/total", data, config);
};

//
//获取非实名在线卡---分页
export const getChargeCardPage = (data = {}, config: objAny = {}) => {
  return request("/oms-operation-service/v1/recharge_card/page", data, config);
};

//获取非实名在线卡---详情
export const getChargeCardDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    "/oms-operation-service/v1/recharge_card/detail",
    data,
    config
  );
};
//充电卡管理 -- 修改电卡状态
export const updateCardStatus = (data = {}, config: objAny = {}) => {
  return request(
    "/oms-operation-service/v1/recharge_card/updateCardStatus",
    data,
    config
  );
};

//非实名在线卡---新增
export const getOpenCard = (data = {}, config: objAny = {}) => {
  return request(
    "/oms-operation-service/v1/recharge_card/open_card",
    data,
    config
  );
};

//非实名在线卡---历史记录详情
export const getOperationDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    "/oms-operation-service/v1/recharge_card/operation_details",
    data,
    config
  );
};

//非实名在线卡---充值
export const rechargeCashCard = (data = {}, config: objAny = {}) => {
  return request(
    "/oms-order-service/v1/transaction/cash/recharge",
    data,
    config
  );
};

//非实名在线卡---编辑
export const editCashCard = (data = {}, config: objAny = {}) => {
  return request(
    "/oms-operation-service/v1/recharge_card/upd_card",
    data,
    config
  );
};
//非实名在线卡---注销
export const cancelCard = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    "/oms-operation-service/v1/recharge_card/cancel_card",
    data,
    config
  );
};

//非实名在线卡---删除
export const deleteCard = (data = {}, config: objAny = {}) => {
  return request(
    "/oms-operation-service/v1/recharge_card/deleteCard",
    data,
    config
  );
};
//获取资金记录--充电
export const getCardRecord = (data = {}, config: objAny = {}) => {
  return request("/oms-charge-service/v1/order/page/card_recode", data, config);
};

//获取资金记录--充值
export const getCardRecharge = (data = {}, config: objAny = {}) => {
  return request(
    "/oms-order-service/v1/card/recode/recharge/page",
    data,
    config
  );
};

//获取资金记录--退款
export const getCardRefund = (data = {}, config: objAny = {}) => {
  return request("/oms-order-service/v1/card/recode/refund/page", data, config);
};
//
